import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, IconButton, makeStyles, Typography, InputBase, Tooltip } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import moment from 'moment';
import * as Yup from 'yup';
import { KeyboardTimePicker } from '@material-ui/pickers';
import AutoCompleteSelect from '../../components/AutoCompleteSelect';
import { TimeIcon, AddIcon, DeleteIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import { checkSubmitData } from '../../../../utils/check';
import { authNameE } from '../../../../utils/userFuncs';
import { store } from '../../../../redux';
import Dialog from '../../../../components/Dialog';
import { dutyAssignAPI } from '../../../../apis';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      padding: '0',
      margin: '0',
      boxShadow: 'unset',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1.875rem 1.875rem 1.563rem 1.587rem',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    margin: '-12px -12px 0 0',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#7d86a9',
    marginBottom: '0.625rem',
  },
  infoIcon: {
    color: '#0e70a5',
    width: '1.25rem',
    height: '1.25rem',
    marginBottom: '0.5rem',
    marginLeft: '0.3rem',
  },
  main: {
    padding: '0 1.563rem',
    overflow: 'auto',
  },
  InputBase: {
    height: '3.75rem',
    borderRadius: '0.225rem',
    border: 'solid 1px #cccccc',
    width: '100%',
    paddingLeft: '1rem',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      color: '#2e4469',
      fontFamily: 'NotoSans-Medium',
    },
  },
  labelError: {
    color: '#f44336',
  },
  inputError: {
    border: '1px solid #f44336',
  },
  errorMsg: {
    margin: '6px 0.125rem 0 0.125rem',
    color: '#f44336',
    fontSize: 12,
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  verify: {
    fontSize: '1rem',
    fontWeight: '500',
    color: '#538fff',
    padding: '0.825rem',
  },
  alert: {
    '& .MuiAlert-standardSuccess': {
      // minWidth: '10rem',
      padding: '0.2rem 1rem',
    },
  },
  keyboardTimeInput: {
    paddingRight: '0',
    '& .MuiFormControl-root': {
      display: 'flex',
      justifyContent: 'center',
    },
    height: '3.5rem',
    width: '100%',
  },
  timeIcon: {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
  },
  addIcon: {
    fontSize: '1rem',
    color: theme.palette.primary.main,
    marginRight: '0.6rem',
  },
  addBtn: {
    color: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
  },
  deleteIcon: {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
    marginLeft: '1rem',
  },
  dialogTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    marginBottom: '0.625rem',
  },
}));

export default function TeamDetails({ closePop, open, title, oldData, confirmClick, isTemplate, isEnableSmartComm}) {
  const copyData = JSON.parse(oldData);
  const loginInfo = useSelector((state) => state.loginInfo);
  const classes = useStyles();
  const [errorMsg, setErrorMsg] = useState(null);
  const [confirmDisabled, setConfirmDisabled] = useState(false);
  const [hasLinkedChatroomDeleted, setHasLinkedChatroomDeleted] = useState(false);
  const roleMap = store.getState()?.roleMap || {};
  const msToTime = (duration) => {
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    const hourStr = hours < 10 ? `0${hours}` : `${hours}`;
    const minuteStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
    return `${hourStr}:${minuteStr}`;
  };

  const getChatBufferTime = (bufferTime, chatTime) => {
    if (bufferTime !== null && bufferTime !== undefined) {
      return `${bufferTime / (1000 * 60)}`;
    } else if (chatTime || chatTime === 0) {
      return '15';
    } else {
      return '';
    }
  };

  const [smartComm, setSmartComm] = useState(false);

   
  const [inputValues, setInputValues] = useState({
    title: copyData?.title,
    chatStartAt:
      copyData?.chatStartAt !== null && copyData?.chatStartAt !== undefined ? msToTime(copyData?.chatStartAt) : '-',
    chatEndAt: copyData?.chatEndAt !== null && copyData?.chatEndAt !== undefined ? msToTime(copyData?.chatEndAt) : '-',
    chatBufferEnterAt: getChatBufferTime(copyData?.chatBufferEnterAt, copyData?.chatStartAt),
    chatBufferLeaveAt: getChatBufferTime(copyData?.chatBufferLeaveAt, copyData?.chatEndAt),
    dutyChats: copyData?.dutyChats ? copyData?.dutyChats : [],
    chatroomNameList: copyData?.chatroomNameList ? copyData?.chatroomNameList : [],
    offDutyOptionList: copyData?.offDutyOptionList ? copyData?.offDutyOptionList : [],
  });

  const [chatroomNameList, setChatroomNameList] = useState([]);
  const [offDutyOptionList, setOffDutyOptionList] = useState([]);
  const [timeInvalid, setTimeInvalid] = useState(false);

  const getDropDownLists = async () => {
    try {
      const { result } = await dutyAssignAPI.getDropDownLists({
        wardId: loginInfo.wardId,
        hospId: loginInfo.hospId,
      });
      const offDutyList = result?.offDuty?.map((item) => {
        let label = '';
        if (item.label === 'Leave') label = i18n.t('DUTYASSIGN_TEAMDETAILS_OFFDUTY_OPTION_LEAVE');
        if (item.label === 'Mute') label = i18n.t('DUTYASSIGN_TEAMDETAILS_OFFDUTY_OPTION_MUTE');
        if (item.label === 'Unmute') label = i18n.t('DUTYASSIGN_TEAMDETAILS_OFFDUTY_OPTION_UNMUTE');
        const offDuty = {
          value: item.value,
          text: label,
        };
        return offDuty;
      });
      const chatList = result?.chatroom?.map((item) => {
        const obsolete = item.extra?.isObsolete ? ` - (${i18n.t('DUTYASSIGN_CREATE_CHATROOM_ABSOLETE')})` : '';
        const chat = {
          value: item.value,
          text: item.label + obsolete,
          selected: false,
          isObsolete: item.extra?.isObsolete,
          categoryPath: item.extra?.categoryPath,
        };
        inputValues.dutyChats.forEach((element) => {
          if (element.chatId === chat.value) {
            chat.selected = true;
          }
        });
        return chat;
      });
      let dutyChats = inputValues.dutyChats?.filter((item) => {
        let exist = chatList?.findIndex((chatroom) => {
          return chatroom.value === item.chatId || item.chatId === -1;
        });
        if (inputValues?.dutyChats?.length === 1 && item.chatId === -1) {
          exist = 0;
        }
        if (exist === -1) {
          setHasLinkedChatroomDeleted(true);
        }
        return exist !== -1;
      });
      if (!dutyChats || dutyChats.length === 0) {
        dutyChats = [
          {
            chatId: -1,
            chatOffDutyCode: -1,
            chatDisplayName: null,
            isObsolete: null,
          },
        ];
      }
      setInputValues({ ...inputValues, dutyChats: dutyChats });
      setOffDutyOptionList(offDutyList);
      setChatroomNameList(chatList);
    } catch (error) {
      console.log('-----Get chatroom list error----->', error);
    }
  };

  useEffect(() => {
    getDropDownLists();
    inputValues.dutyChats =
      copyData?.dutyChats?.length > 0
        ? copyData?.dutyChats
        : [
            {
              chatId: -1,
              chatOffDutyCode: -1,
              chatDisplayName: null,
              isObsolete: null,
            },
          ];
    setInputValues({ ...inputValues });
  }, []);

  useEffect(() => {
    checkStartEndTime();
  }, [inputValues]);

  useEffect(() => {
    if (errorMsg) {
      if (errorMsg.title || errorMsg.chatStartAt || errorMsg.chatEndAt) {
        setConfirmDisabled(true);
      } else {
        setConfirmDisabled(false);
      }
    } else {
      setConfirmDisabled(false);
    }
    if (timeInvalid) {
      setConfirmDisabled(true);
    }

    checkSmartComm();
  }, [errorMsg, timeInvalid]);

  const schema = {
    title: Yup.string()
      .transform((value) => value?.trim())
      .max(30, i18n.t('DUTYASSIGN_CHECK_TITLE_LENGTH', { value: 30 }))
      .required(i18n.t('DUTYASSIGN_CHECK_TITLE_MSG', { value: i18n.t('DUTYASSIGN_CHECK_TITLE') })),
  };

  const focusCheck = (name) => {
    return async () => {
      try {
        await checkSubmitData(Yup.object().shape({ [name]: schema[name] }), { [name]: inputValues[name] });
        setErrorMsg({ ...errorMsg, [name]: null });
      } catch (e) {
        setErrorMsg({ ...errorMsg, ...e });
      }
    };
  };
  const checkTimeInvalid = () => {
    if (inputValues.chatStartAt === 'Invalid date' || inputValues.chatEndAt === 'Invalid date') {
      setTimeInvalid(true);
    } else {
      setTimeInvalid(false);
    }
  };
  const checkStartEndTime = () => {
    checkTimeInvalid();
    let chatStartMsg = null;
    let chatEndMsg = null;
    if (inputValues.dutyChats?.filter((item) => item.chatId !== -1)?.length > 0) {
      if (inputValues.chatStartAt === null || inputValues.chatStartAt === '-' || inputValues.chatStartAt === '') {
        chatStartMsg = i18n.t('DUTYASSIGN_TEAMDETAILS_START_TIME_EMPTY');
      } else {
        setErrorMsg({ ...errorMsg, chatStartAt: null });
      }
      if (inputValues.chatEndAt === null || inputValues.chatEndAt === '-' || inputValues.chatEndAt === '') {
        chatEndMsg = i18n.t('DUTYASSIGN_TEAMDETAILS_END_TIME_EMPTY');
      }
      if (
        inputValues.chatEndAt !== null &&
        inputValues.chatEndAt !== '-' &&
        inputValues.chatEndAt !== '' &&
        inputValues.chatStartAt !== null &&
        inputValues.chatStartAt !== '-' &&
        inputValues.chatStartAt !== ''
      ) {
        if (moment(inputValues.chatEndAt, 'HH:mm') <= moment(inputValues.chatStartAt, 'HH:mm')) {
          if (inputValues.chatEndAt === '00:00:00' || inputValues.chatEndAt === '00:00') {
            setErrorMsg({ ...errorMsg, chatEndMsg: null });
          } else {
            chatEndMsg = i18n.t('DUTYASSIGN_TEAMDETAILS_START_TIME_GREATER');
          }
        }
      }
    } else {
      if (inputValues.chatStartAt && inputValues.chatStartAt !== '-') {
        if (inputValues.chatEndAt === null || inputValues.chatEndAt === '' || inputValues.chatEndAt === '-') {
          chatEndMsg = i18n.t('DUTYASSIGN_TEAMDETAILS_END_TIME_EMPTY');
        } else if (moment(inputValues.chatEndAt, 'HH:mm') <= moment(inputValues.chatStartAt, 'HH:mm')) {
          if (inputValues.chatEndAt === '00:00:00' || inputValues.chatEndAt === '00:00') {
            setErrorMsg({ ...errorMsg, chatEndMsg: null });
          } else {
            chatEndMsg = i18n.t('DUTYASSIGN_TEAMDETAILS_START_TIME_GREATER');
          }
        }
      } else {
        if (inputValues.chatEndAt && inputValues.chatEndAt !== '-') {
          chatStartMsg = i18n.t('DUTYASSIGN_TEAMDETAILS_START_TIME_EMPTY');
        }
      }
    }
    setErrorMsg({ ...errorMsg, chatEndAt: chatEndMsg, chatStartAt: chatStartMsg });
  };

  const selectOptionHandle = (value, index) => {
    const opt = offDutyOptionList.find((item) => {
      return item.value === value;
    });
    inputValues.dutyChats[index].chatOffDutyCode = opt.value;
    setInputValues({ ...inputValues });
  };
  const selectChatroomHandle = (value, index) => {
    chatroomNameList.forEach((item) => {
      if (item.value === inputValues.dutyChats[index].chatId) {
        item.selected = false;
      }
    });
    const chatroom = chatroomNameList.find((item) => {
      if (item.value === value) {
        item.selected = true;
      }
      return item.value === value;
    });
    inputValues.dutyChats[index].chatId = chatroom.value;
    inputValues.dutyChats[index].isObsolete = chatroom.isObsolete;
    inputValues.dutyChats[index].chatDisplayName = chatroom.text;
    if (inputValues.dutyChats[index].chatOffDutyCode === -1 || inputValues.dutyChats[index].chatOffDutyCode === null) {
      inputValues.dutyChats[index].chatOffDutyCode = 0;
    }
    setInputValues({ ...inputValues });
  };

  const addChatroom = () => {
    const chatroom = {
      chatId: -1,
      chatOffDutyCode: -1,
      chatDisplayName: null,
      isObsolete: null,
    };
    inputValues.dutyChats.push(chatroom);
    setInputValues({ ...inputValues });
  };

  const deleteHandle = (index) => {
    chatroomNameList.forEach((item) => {
      if (item.value === inputValues.dutyChats[index].chatId) {
        item.selected = false;
      }
    });
    inputValues.dutyChats.splice(index, 1);
    setInputValues({ ...inputValues });
  };

  const saveHandle = () => {
    if (inputValues.title?.length === 0 || inputValues.title?.length > 30 || !inputValues.title?.trim()) {
      (async () => {
        await focusCheck()();
      })();
      return;
    }
    const formatStartTime = moment(inputValues.chatStartAt, 'HH:mm').format('HH:mm').split(':');
    const formatEndTime = moment(inputValues.chatEndAt, 'HH:mm').format('HH:mm').split(':');
    const msStartTime =
      formatStartTime.length > 1 ? formatStartTime[0] * 3600 * 1000 + formatStartTime[1] * 60 * 1000 : null;
    const msEndTime = formatEndTime.length > 1 ? formatEndTime[0] * 3600 * 1000 + formatEndTime[1] * 60 * 1000 : null;
    const saveData = {
      title: inputValues.title.trim(),
      chatStartAt: msStartTime,
      chatEndAt: msEndTime === 0 ? 24 * 3600 * 1000 : msEndTime,
      chatBufferEnterAt: inputValues.chatBufferEnterAt === '' ? null : inputValues.chatBufferEnterAt * 1000 * 60,
      chatBufferLeaveAt: inputValues.chatBufferLeaveAt === '' ? null : inputValues.chatBufferLeaveAt * 1000 * 60,
      dutyChats: inputValues.dutyChats?.filter((item) => {
        return item.chatId !== -1;
      }),
    };
    confirmClick(saveData);
  };
  const defaultBufferTime = (bufferTime, chatTime) => {
    if (bufferTime) {
      return bufferTime;
    } else if (chatTime) {
      return '15';
    } else {
      return '0';
    }
  };

  const checkSmartComm =()=>{
    
    if(roleMap[authNameE.dutyAssign_Enable_Smart_Communication]){
      
        setSmartComm(isEnableSmartComm);
      
    }
    
  };
  
  const dutyChats = () => {
    return inputValues.dutyChats.map((chatroom, index) => {
      // add selected chatroom to self
      const selfItem = chatroomNameList?.find((element) => element.value === chatroom.chatId);
      let dropDownList = chatroomNameList?.filter((item) => {
        return item.selected === false;
      });
      if (selfItem) {
        dropDownList?.unshift(selfItem);
        dropDownList = _.orderBy(dropDownList, ['isObsolete', (item) => item.text.toLowerCase()], ['asc', 'asc']);
      }
      return (
        <Box
          display="flex"
          mb="2.175rem"
          key={`AutoCompleteSelect${chatroom.chatId}${new Date().getTime()}${index}`}
          style={{ flexDirection: 'row', height: '2rem', alignItems: 'center' }}
        >
          <Box style={{ width: '65%', marginRight: '1.275rem' }}>
            <AutoCompleteSelect
              value={chatroom.chatId}
              categoryPath={selfItem?.categoryPath}
              placeholder={i18n.t('DUTYASSIGN_CREATE_CHATROOM_NAME')}
              itemList={dropDownList}
              onChange={(value) => selectChatroomHandle(value, index)}
              id={`select_chatroom_ ${index}`}
            />
          </Box>
          <Box style={{ width: '25%' }}>
            <AutoCompleteSelect
              value={chatroom.chatOffDutyCode}
              placeholder={i18n.t('DUTYASSIGN_TEAMDETAILS_OFFDUTY_OPTION_PLACEHOLDER')}
              itemList={offDutyOptionList}
              onChange={(value) => selectOptionHandle(value, index)}
              id={`select_option_ ${index}`}
            />
          </Box>
          <Box style={{ width: '10%' }}>
            <DeleteIcon className={classes.deleteIcon} onClick={() => deleteHandle(index)} />
          </Box>
        </Box>
      );
    });
  };

  return (
    <Dialog
      open={open}
      disabled={confirmDisabled}
      className={classes.dialog}
      title={title}
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('EQUIPMENT_ADS_POPUP_CONFIRM')}
      cancelID="dutyAssign-item-details-dialog-ahd-cancel"
      confirmID="dutyAssign-item-details-dialog-ahd-confirm"
      closeID="dutyAssign-item-details-dialog-ahd-close"
      handleClose={() => {
        closePop();
        setErrorMsg(null);
      }}
      handleCancel={() => {
        closePop();
        setErrorMsg(null);
      }}
      handleConfirm={() => {
        saveHandle();
        closePop();
      }}
    >
      {hasLinkedChatroomDeleted && (
        <Dialog
          open={hasLinkedChatroomDeleted}
          title={i18n.t('DUTYASSIGN_TEAMDETAILS_DELETE_TIPS_TITLE')}
          confirm={i18n.t('EQUIPMENT_CONFIRM_OK')}
          handleClose={() => {
            setHasLinkedChatroomDeleted(false);
            saveHandle();
          }}
          handleConfirm={() => {
            setHasLinkedChatroomDeleted(false);
            saveHandle();
          }}
        >
          <div
            style={{
              color: '#2e4469',
              fontSize: '1.25rem',
              fontFamily: 'NotoSans-Medium',
              fontWeight: 500,
              lineHeight: '1.875rem',
            }}
          >
            {i18n.t('DUTYASSIGN_TEAMDETAILS_DELETE_TIPS_CONTENT')}
          </div>
        </Dialog>
      )}
      <Box display="flex" mb="1.875rem">
        <Box width="100%">
          <div className={classes.dialogTitle}>
            {i18n.t('DUTYASSIGN_TEAMDETAILS_NAME')}
            <span style={{ color: 'red', paddingLeft: '0.3rem' }}>*</span>
          </div>
          <Box borderRadius="0.625rem">
            <InputBase
              id="team_details_title"
              value={inputValues.title}
              className={classes.InputBase}
              placeholder={i18n.t('DUTYASSIGN_TEAMDETAILS_NAME')}
              onChange={(event) => {
                setInputValues({ ...inputValues, title: event.target.value });
              }}
              onBlur={() => {
                (async () => {
                  await focusCheck('title')();
                })();
              }}
            />
            {errorMsg?.title ? <Typography className={classes.errorMsg}>{errorMsg.title}</Typography> : ''}
          </Box>
        </Box>
      </Box>
      {Boolean((roleMap[authNameE.dutyAssign_Edit_Role_Duty_Detail] || smartComm)) && (
        <Box>
          <Box display="flex" mb="1.875rem">
            <Box width="50%" mr="1.275rem">
              <Typography className={classes.label}>{i18n.t('DUTYASSIGN_TEAMDETAILS_START_TIME')}</Typography>
              <KeyboardTimePicker
                ampm={false}
                id="team_details_chatStartAt"
                className={classes.keyboardTimeInput}
                keyboardIcon={<TimeIcon className={classes.timeIcon} id="team_details_chatStartAt_select_btn" />}
                inputVariant="outlined"
                InputAdornmentProps={{ position: 'end' }}
                variant="dialog"
                placeholder={i18n.t('DUTYASSIGN_TEAMDETAILS_START_TIME')}
                value={inputValues.chatStartAt === '-' ? null : moment(inputValues.chatStartAt, 'HH:mm')}
                onChange={(value) => {
                  if ((value?.['_i'] && value?.['_i']?.[6] === '_') || value === null) {
                    setInputValues({ ...inputValues, chatStartAt: '-' });
                    return;
                  }
                  const bufferEnterTime = defaultBufferTime(inputValues.chatBufferEnterAt, inputValues.chatStartAt);
                  setInputValues({
                    ...inputValues,
                    chatStartAt: moment(value).format('HH:mm'),
                    chatBufferEnterAt: bufferEnterTime,
                  });
                }}
                onBlur={() => {
                  checkStartEndTime();
                }}
              />
              {errorMsg?.chatStartAt ? (
                <Typography id="team_details_chatStartAt_error" className={classes.errorMsg}>
                  {errorMsg.chatStartAt}
                </Typography>
              ) : (
                ''
              )}
            </Box>
            <Box width="50%">
              <Typography className={classes.label}>{i18n.t('DUTYASSIGN_TEAMDETAILS_END_TIME')}</Typography>
              <KeyboardTimePicker
                id="team_details_chatEndAt"
                className={classes.keyboardTimeInput}
                keyboardIcon={<TimeIcon className={classes.timeIcon} id="team_details_chatEndAt_select_btn" />}
                inputVariant="outlined"
                InputAdornmentProps={{ position: 'end' }}
                ampm={false}
                variant="dialog"
                placeholder={i18n.t('DUTYASSIGN_TEAMDETAILS_END_TIME')}
                value={inputValues.chatEndAt === '-' ? null : moment(inputValues.chatEndAt, 'HH:mm')}
                onChange={(value) => {
                  if ((value?.['_i'] && value?.['_i']?.[6] === '_') || value === null) {
                    setInputValues({ ...inputValues, chatEndAt: '-' });
                    return;
                  }
                  const bufferLeaveTime = defaultBufferTime(inputValues.chatBufferLeaveAt, inputValues.chatEndAt);
                  setInputValues({
                    ...inputValues,
                    chatEndAt: moment(value).format('HH:mm'),
                    chatBufferLeaveAt: bufferLeaveTime,
                  });
                }}
                onBlur={() => {
                  checkStartEndTime();
                }}
              />
              {errorMsg?.chatEndAt ? (
                <Typography id="team_details_chatEndAt_error" className={classes.errorMsg}>
                  {errorMsg.chatEndAt}
                </Typography>
              ) : (
                ''
              )}
            </Box>
          </Box>
          <Box display="flex" mb="1.875rem">
            <Box width="50%" mr="1.275rem">
              <Box width="100%" display="flex" style={{ alignItems: 'center' }}>
                <Typography className={classes.label}>{i18n.t('DUTYASSIGN_TEAMDETAILS_BUFFER_ENTER_TIME')}</Typography>
                <Tooltip
                  id="team_details_chatBufferEnterAt_tips"
                  title={
                    <Typography style={{ fontSize: 12, color: 'white' }}>
                      {i18n.t('DUTYASSIGN_TEAMDETAILS_TEAM_BUFFER_BEFORE_TIPS')}
                    </Typography>
                  }
                  className={classes.infoIcon}
                  style={{ marginBottom: '0.5rem', marginLeft: '0.3rem' }}
                >
                  <IconButton>
                    <ErrorIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <InputBase
                id="team_details_chatBufferEnterAt"
                value={inputValues.chatBufferEnterAt}
                className={classes.InputBase}
                type="number"
                placeholder={i18n.t('DUTYASSIGN_TEAMDETAILS_BUFFER_ENTER_TIME')}
                onKeyDown={(e) => {
                  if (
                    e.nativeEvent.key === '.' ||
                    e.nativeEvent.key === 'e' ||
                    e.nativeEvent.key === '+' ||
                    e.nativeEvent.key === '-'
                  ) {
                    e.preventDefault();
                  }
                }}
                onChange={(event) => {
                  const { value } = event.target;
                  if (value > 1440) {
                    event.preventDefault();
                    event.target.value = 1440;
                  }

                  (async () => {
                    setInputValues({ ...inputValues, chatBufferEnterAt: event.target.value });
                  })();
                }}
                onBlur={(e) => {
                  if (
                    (inputValues.chatBufferEnterAt === null || inputValues.chatBufferEnterAt === '') &&
                    inputValues.chatStartAt !== '' &&
                    inputValues.chatStartAt !== '-' &&
                    inputValues.chatStartAt !== null
                  ) {
                    inputValues.chatBufferEnterAt = '0';
                  }
                  setInputValues({ ...inputValues });
                }}
              />
            </Box>
            <Box width="50%">
              <Box width="100%" display="flex" style={{ alignItems: 'center' }}>
                <Typography className={classes.label}>{i18n.t('DUTYASSIGN_TEAMDETAILS_BUFFER_LEAVE_TIME')}</Typography>
                <Tooltip
                  id="team_details_chatBufferLeaveAt_tips"
                  title={
                    <Typography style={{ fontSize: 12, color: 'white' }}>
                      {i18n.t('DUTYASSIGN_TEAMDETAILS_TEAM_BUFFER_AFTER_TIPS')}
                    </Typography>
                  }
                  className={classes.infoIcon}
                  style={{ marginBottom: '0.5rem', marginLeft: '0.3rem' }}
                >
                  <IconButton>
                    <ErrorIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <InputBase
                id="team_details_chatBufferLeaveAt"
                value={inputValues.chatBufferLeaveAt}
                className={classes.InputBase}
                type="number"
                placeholder={i18n.t('DUTYASSIGN_TEAMDETAILS_BUFFER_LEAVE_TIME')}
                onKeyDown={(e) => {
                  if (
                    e.nativeEvent.key === '.' ||
                    e.nativeEvent.key === 'e' ||
                    e.nativeEvent.key === '+' ||
                    e.nativeEvent.key === '-'
                  ) {
                    e.preventDefault();
                  }
                }}
                onChange={(event) => {
                  const { value } = event.target;
                  if (value > 1440) {
                    event.preventDefault();
                    event.target.value = 1440;
                  }
                  (async () => {
                    setInputValues({ ...inputValues, chatBufferLeaveAt: event.target.value });
                  })();
                }}
                onBlur={() => {
                  if (
                    (inputValues.chatBufferLeaveAt === null || inputValues.chatBufferLeaveAt === '') &&
                    inputValues.chatEndAt !== '' &&
                    inputValues.chatEndAt !== '-' &&
                    inputValues.chatEndAt !== null
                  ) {
                    inputValues.chatBufferLeaveAt = '0';
                  }
                  setInputValues({ ...inputValues });
                }}
              />
            </Box>
          </Box>
          <Box>
            {inputValues.dutyChats?.length > 0 ? (
              <Box mb="1.875rem">
                <Box display="flex" style={{ flexDirection: 'row', width: '100%', marginBottom: '0.75rem' }}>
                  <Box style={{ width: '65%', marginRight: '1.275rem' }}>
                    <Typography className={classes.label}>{i18n.t('DUTYASSIGN_CREATE_CHATROOM_NAME')}</Typography>
                  </Box>
                  <Box style={{ width: '25%' }}>
                    <Typography className={classes.label}>{i18n.t('DUTYASSIGN_TEAMDETAILS_OFFDUTY_OPTION')}</Typography>
                  </Box>
                  <Box style={{ width: '10%' }}>
                    <Typography className={classes.label}> </Typography>
                  </Box>
                </Box>

                {dutyChats()}
              </Box>
            ) : null}
          </Box>

          <Box display="flex" alignItems="center">
            <ButtonBase
              id="team_details_add_chatroom"
              className={classes.addBtn}
              style={{ marginRight: '1.313rem' }}
              onClick={addChatroom}
            >
              <AddIcon className={classes.addIcon} />
              {i18n.t('DUTYASSIGN_TEAMDETAILS_ADD_CHATROOM')}
            </ButtonBase>
          </Box>
        </Box>
      )}
      <div style={{ marginTop: '0.625rem' }} id="team_details_info_message">
        <span style={{ color: 'red', fontSize: '1rem' }}>{'* '}</span>
        <span style={{ color: 'black', fontSize: '1rem', fontStyle: 'italic' }}>
          {i18n.t('BEDSTATUS_STAR_IS_REQUIRED_FIELD')}
        </span>
      </div>
    </Dialog>
  );
}
